export const sortPeriods = (periods: Set<string>) => Array.from(periods).sort((a, b) => b.localeCompare(a));
